import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSessionStore = defineStore('session', () => {
  const showSessionExpiredModal = ref(false)
  let expirationTimerId: ReturnType<typeof setTimeout> | null = null

  function showExpiredModal() {
    showSessionExpiredModal.value = true
  }

  function hideExpiredModal() {
    showSessionExpiredModal.value = false
  }

  function startExpirationTimer(expiresAt: number, onExpire?: () => void) {
    clearExpirationTimer()
    const delay = expiresAt - Date.now()

    const fire = () => {
      showExpiredModal()
      if (onExpire) onExpire()
    }

    if (delay <= 0) {
      fire()
      return
    }

    expirationTimerId = setTimeout(fire, delay)
  }

  function clearExpirationTimer() {
    if (expirationTimerId !== null) {
      clearTimeout(expirationTimerId)
      expirationTimerId = null
    }
  }

  return {
    showSessionExpiredModal,
    showExpiredModal,
    hideExpiredModal,
    startExpirationTimer,
    clearExpirationTimer,
  }
})
